import { ReactNode } from "react";
import styled from "styled-components";

export interface IMenuCard {
  icon: ReactNode;
  title: string;
  color: string;
  description: string;
  action: () => void;
}

const MenuWrapper = styled.div<{ color: string }>`
  width: 100%;
  padding: 1.5rem;
  border-left: 0.5rem solid ${({ color }) => color};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 2rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.bg.prim_500};
  cursor: pointer;
  box-shadow: ${({ theme }) => theme.shadow.shad_100};

  .l-info {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    h2 {
      font-weight: 600;
      font-size: 1.2rem;
    }

    h3 {
      font-size: 0.85rem;
      color: ${({ theme }) => theme.text.prim_200};
      font-weight: 400;
    }
  }
`;

const Menucard = ({ icon, title, color, description, action }: IMenuCard) => {
  return (
    <MenuWrapper color={color} onClick={action}>
      {icon}
      <div className="l-info">
        <h2>{description}</h2>
        <h3>{title}</h3>
      </div>
    </MenuWrapper>
  );
};

export default Menucard;
